// src/modules/leads/route-planner/RouteSharePanel.js
import React from 'react';
import { FaCopy, FaCheck, FaExternalLinkAlt, FaShareAlt, FaRedoAlt } from 'react-icons/fa';
import {
  SectionTitle, RouteSummaryBar, RouteSummaryStat,
  ShareUrlBox, CopyButton, PrimaryButton, SecondaryButton, Divider,
} from './routePlannerStyles';

const RouteSharePanel = ({
  routeInfo,
  routeStops,
  googleMapsUrl,
  copied,
  onCopy,
  onOpenInMaps,
  onShare,
  onReset,
}) => {
  const canShare = typeof navigator !== 'undefined' && navigator.share;

  return (
    <div>
      <SectionTitle>Route Summary</SectionTitle>

      {routeInfo && (
        <RouteSummaryBar>
          <RouteSummaryStat>
            <div className="value">{routeStops.length}</div>
            <div className="label">Stops</div>
          </RouteSummaryStat>
          <RouteSummaryStat>
            <div className="value">{routeInfo.totalDistance}</div>
            <div className="label">Distance</div>
          </RouteSummaryStat>
          <RouteSummaryStat>
            <div className="value">{routeInfo.totalDuration}</div>
            <div className="label">Drive Time</div>
          </RouteSummaryStat>
        </RouteSummaryBar>
      )}

      <Divider />
      <SectionTitle>Share Route</SectionTitle>

      {googleMapsUrl && (
        <>
          <ShareUrlBox>
            <input type="text" value={googleMapsUrl} readOnly />
            <CopyButton copied={copied} onClick={onCopy}>
              {copied ? <><FaCheck /> Copied!</> : <><FaCopy /> Copy</>}
            </CopyButton>
          </ShareUrlBox>

          <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
            <PrimaryButton onClick={onOpenInMaps} style={{ flex: 1 }}>
              <FaExternalLinkAlt /> Open in Google Maps
            </PrimaryButton>
          </div>

          {canShare && (
            <SecondaryButton onClick={onShare} style={{ width: '100%', marginBottom: '12px' }}>
              <FaShareAlt /> Send to Phone
            </SecondaryButton>
          )}
        </>
      )}

      <Divider />

      <SecondaryButton onClick={onReset} style={{ width: '100%' }}>
        <FaRedoAlt /> Plan New Route
      </SecondaryButton>
    </div>
  );
};

export default RouteSharePanel;
